/**
 * Статус соединения в сети
 */
export const CONNECTION_STATUS = {
  AUTHORIZED: "AUTHORIZED",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  UNPAID: "UNPAID",
  UNKNOWN: "UNKNOWN",
};
